import { Container, Grid } from "@material-ui/core";
import queryString from "query-string";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteChildrenProps, useHistory } from "react-router-dom";
import { BasContext, BasContextProvider } from "src/contexts/bas";
import { Footer } from "../../Footer";
import { Page } from "../../partials/Page";
import { ButtonLarge } from "./components/ButtonLarge";
import { ColumnBlock } from "./components/ColumnBlock";
import { FullWidthAnimationBlock } from "./components/FullWidthAnimationBlock";
import { FullWidthBigBlock } from "./components/FullWidthBigBlock";
import { Head } from "./components/Head";
import { ImgBlock } from "./components/ImgBlock";
import { PhoneAnimation } from "./components/PhoneAnimation";
import { RegisterDialog } from "./components/RegisterDialog";
import { TableBlock } from "./components/TableBlock";
import { TextBlock } from "./components/TextBlock";

export const BecomeAStreamerPage = () => {
  const { bas } = useContext(BasContext);
  const [openRegistration, setOpenRegistration] = useState<boolean>(false);
  const history = useHistory();
  const queryParams = queryString.parse(history.location.search);

  useEffect(() => {
    if (queryParams.signUp) {
      setOpenRegistration(true);
    }
  }, []);

  return (
    <>
      <Container maxWidth={false} disableGutters>
        {/* Head */}
        <Head
          headlineOne={bas?.attributes.head.text.headerOne}
          p1={bas?.attributes.head.text.bodyOne}
          color={"primary"}
          bgColor={"#1F2833"}
        >
          <ButtonLarge buttonText={bas?.attributes.head.cta?.cta}></ButtonLarge>
        </Head>
        {/* Mission section */}
        <Grid container spacing={0}>
          <TextBlock
            headlineOne={bas?.attributes.missionSection.text.headerOne}
            headlineTwo={bas?.attributes.missionSection.text.headerTwo}
            p1={bas?.attributes.missionSection.text.bodyOne}
            p2={bas?.attributes.missionSection.text.bodyTwo}
            bgColor={"#FEE9EE"}
            color={"primary"}
          />
          <ImgBlock
            bgImg={
              bas?.attributes.missionSection.imgMission.data.attributes.url
            }
            bgPositionDesktop={"center left"}
            bgPositionMobile={"center center"}
          />
        </Grid>
        {/* Text Animation */}
        <FullWidthAnimationBlock
          headerOne={
            "Challenges Boot camps Courses Workouts Lectures Challenges"
          }
          headerTwo={"Workouts Lectures Challenges Boot camps Courses"}
        />
        {/* Streamer section */}
        <Grid container spacing={0}>
          <ImgBlock
            bgImg={bas?.attributes.streamerSection.img.data.attributes.url}
            bgPositionDesktop={"center left"}
            bgPositionMobile={"center center"}
          />
          <TextBlock
            headlineOne={bas?.attributes.streamerSection.text.headerOne}
            headlineTwo={bas?.attributes.streamerSection.text.headerTwo}
            p1={bas?.attributes.streamerSection.text.bodyOne}
            p2={bas?.attributes.streamerSection.text.bodyTwo}
            bgColor={"#f2f2f1"}
            color={"primary.dark"}
          >
            <ButtonLarge
              buttonText={bas?.attributes.streamerSection.cta?.cta}
            ></ButtonLarge>
          </TextBlock>
        </Grid>

        {/* Like section */}
        <Grid container>
          <ColumnBlock
            headlineOne={bas?.attributes.likeSection.headerBody[0].headerOne}
            headlineTwo={bas?.attributes.likeSection.headerBody[0].bodyOne}
            bgImg={bas?.attributes.likeSection.img.data.attributes.url}
            color={"primary"}
            bgColor={"#1F2833"}
            colOnesubHeader={
              bas?.attributes.likeSection.headerBody[1].headerOne
            }
            colOneP1={bas?.attributes.likeSection.headerBody[1].bodyOne}
            colTwosubHeader={
              bas?.attributes.likeSection.headerBody[2].headerOne
            }
            colTwoP1={bas?.attributes.likeSection.headerBody[2].bodyOne}
            colThreesubHeader={
              bas?.attributes.likeSection.headerBody[3].headerOne
            }
            colThreeP1={bas?.attributes.likeSection.headerBody[3].bodyOne}
            colFoursubHeader={
              bas?.attributes.likeSection.headerBody[4].headerOne
            }
            colFourP1={bas?.attributes.likeSection.headerBody[4].bodyOne}
          />
          {/* Kvix Page */}
          <Grid container spacing={0}>
            <TextBlock
              headlineOne={bas?.attributes.kvixPage.text.headerOne}
              headlineTwo={bas?.attributes.kvixPage.text.headerTwo}
              p1={bas?.attributes.kvixPage.text.bodyOne}
              p2={bas?.attributes.kvixPage.text.bodyTwo}
              bgColor={"#FD9BB5"}
              color={"primary"}
            />
            <ImgBlock
              bgImg={bas?.attributes.kvixPage.img.data.attributes.url}
              bgPositionDesktop={"center"}
              bgPositionMobile={"center"}
            />
          </Grid>
          {/* Filler Section */}
          <FullWidthBigBlock
            headlineOne={bas?.attributes.fillerSection.text.headerOne}
            bgImg={bas?.attributes.fillerSection.img.data.attributes.url}
            color={"primary"}
            bgColor={"none"}
            bgPositionDesktop={"center 75%"}
            bgPositionMobile={"center"}
          />
          {/* Fifty Fifty */}
          <Grid container spacing={0}>
            <TextBlock
              headlineOne={bas?.attributes.fiftyFifty.text.headerOne}
              headlineTwo={bas?.attributes.fiftyFifty.text.headerTwo}
              p1={bas?.attributes.fiftyFifty.text.bodyOne}
              p2={bas?.attributes.fiftyFifty.text.bodyTwo}
              bgColor={"#FEE9EE"}
              color={"primary"}
            >
              <ButtonLarge
                buttonText={bas?.attributes.fiftyFifty.cta?.cta}
              ></ButtonLarge>
            </TextBlock>
            <TableBlock
              subHeadOne={bas?.attributes.numbers.headerBody[0].headerOne}
              bodyOne={bas?.attributes.numbers.headerBody[0].bodyOne}
              subHeadTwo={bas?.attributes.numbers.headerBody[1].headerOne}
              bodyTwo={bas?.attributes.numbers.headerBody[1].bodyOne}
              subHeadThree={bas?.attributes.numbers.headerBody[2].headerOne}
              bodyThree={bas?.attributes.numbers.headerBody[2].bodyOne}
              color={"primary"}
              bgColor={undefined}
              bgImg={bas?.attributes.numbers.imgNumbers?.data.attributes.url}
              bgPositionDesktop={"center"}
              bgPositionMobile={"center"}
            />
          </Grid>
          {/* Marketing Section */}
          <Grid container spacing={0}>
            <TextBlock
              headlineOne={bas?.attributes.marketingSection.text.headerOne}
              headlineTwo={bas?.attributes.marketingSection.text.headerTwo}
              p1={bas?.attributes.marketingSection.text.bodyOne}
              p2={bas?.attributes.marketingSection.text.bodyTwo}
              bgColor={"#ffffff"}
              color={"primary"}
            />
            <PhoneAnimation />
          </Grid>
          {/* Level 10 desktop */}
          <FullWidthBigBlock
            headlineOne={bas?.attributes.foot.text.headerOne}
            p1={bas?.attributes.foot.text.bodyOne}
            bgImg={bas?.attributes.foot.text.bodyOne}
            color={"primary"}
            bgColor={"#1F2833"}
          >
            <ButtonLarge
              buttonText={bas?.attributes.foot.cta?.cta}
            ></ButtonLarge>
          </FullWidthBigBlock>
        </Grid>
      </Container>
      <RegisterDialog open={openRegistration} setOpen={setOpenRegistration} />
    </>
  );
};

export const BecomeAStreamer: React.FC<RouteChildrenProps> = (props) => {
  const { t, ready } = useTranslation("seo");
  const metaObj = {
    title: t("kvixTV.title"),
    description: t("kvixTV.description"),
    ogTitle: t("kvixTV.ogTitle"),
    ogImage: t("kvixTV.ogImage"),
  };

  if (!ready) {
    return null;
  }

  return (
    <BasContextProvider>
      <Page noGutter meta={metaObj}>
        <BecomeAStreamerPage />
        <Footer noGutter />
      </Page>
    </BasContextProvider>
  );
};

export default BecomeAStreamer;
